// extracted by mini-css-extract-plugin
module.exports = {"bar":"styles_bar__1Qicw","logo":"styles_logo__2qGm4"};